if (!customElements.get('melty-order')) {
  customElements.define('melty-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variant = this.querySelector('[data-ml-variant]');
      this.link = this.querySelector('[data-ml-order-link]');
      this.variant.addEventListener('change', () => this.update(true));
      this.link.addEventListener('click', () => this.update(false));
      this.update(false);
    }
    update(changeMedia) {
      const option = this.variant.tagName === 'SELECT' ? this.variant.selectedOptions[0] : this.variant;
      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', this.variant.value);
      const values = { product: this.dataset.product, variant: option.dataset.title, url: url.href };
      let message = this.dataset.messageTemplate;
      for (const [key, value] of Object.entries(values)) message = message.replaceAll(`[[${key}]]`, () => value);
      this.link.href = `https://wa.me/${this.dataset.phone}?text=${encodeURIComponent(message)}`;
      if (changeMedia && option.dataset.mediaId) {
        const gallery = this.closest('.shopify-section')?.querySelector('media-gallery');
        if (typeof gallery?.setActiveMedia === 'function') gallery.setActiveMedia(`${this.dataset.sectionId}-${option.dataset.mediaId}`, true);
      }
    }
  });
}
